import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=451bc584&"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=451bc584&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VParallax } from 'vuetify/lib/components/VParallax';
installComponents(component, {VBtn,VParallax})
